import $ from 'jquery'
require('bootstrap/js/src/toast')

import Stickyfill from 'stickyfill'
try {
  const stickyfill = Stickyfill()
  const element = document.querySelectorAll('.js-top-nav-sticky')[0];
  stickyfill.add(element);
} catch (e) {
  console.log(e)
}


import svg4everybody from 'svg4everybody'
svg4everybody()


$('.js-tab').click(function(){
  $(this).addClass('is-active').siblings().removeClass('is-active')
  $(
    $(this).data('tab')
  ).removeClass('d-lg-none').siblings().addClass('d-lg-none')
})

let delivery_info_loaded = false
$('.js-delivery-info-tab').click(function() {
  if (delivery_info_loaded)
    return

  $.get('/api/delivery_info', resp => {
    delivery_info_loaded = true
    $('.js-delivery-info-block').html(resp)
  })
})




$('.toast').toast()
$('.toast').toast('show')


let origButtonText = null
$('.js-upload-file-change-label input').change(function(){
  origButtonText = origButtonText || $(this).next().text()
  $(this).next().text(
    [...this.files].map(f => f.name.length > 10 ? f.name.substr(0, 9) + '…' : f.name).join(', ').substr(0, 33) || origButtonText
  )
})


$('.js-prevent-bubble').click(e => {e.stopPropagation(); e.preventDefault();})

